import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-header',
  templateUrl: './error-header.component.html',
  styleUrls: ['./error-header.component.scss'],
})
export class ErrorHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
